import { makeStyles } from '@mui/styles';
// import { palette } from '@livable/saas-react-components';

const useStyles = makeStyles({});
export default useStyles;